const types = [
  {
    value: 'STR',
    label: 'STR',
  },
  {
    value: 'INT',
    label: 'INT',
  },
  {
    value: 'DEX',
    label: 'DEX',
  },
  {
    value: 'MNT',
    label: 'MNT',
  },
  {
    value: 'GP',
    label: 'G-Points',
  },
  {
    value: 'SP',
    label: 'Skill Points',
  },
];

export default types;
